module.exports = __webpack_public_path__ + "static/media/how_is.8afb36fb.vtt";